export const sidebarAction = {
  setOpen: (value) => ({
    type: 'SIDEBAR/SET_OPEN',
    payload: value
  })
}
